const toNumber = (value) => Number(value) || 0;

export const buildChartData = (data) => ({
    labels: ['FPY', 'Retest'],
    datasets: [
        {
            data: [toNumber(data.PASS), toNumber(data.FAIL)],
            backgroundColor: ['#2f9e44', '#d64545'],
            hoverBackgroundColor: ['#40c057', '#ef6b6b'],
            borderColor: '#ffffff',
            borderWidth: 3,
        },
    ],
});

export const getPieMetrics = (data, totalProduction) => {
    const passPercentage = toNumber(data.PASS);
    const failPercentage = toNumber(data.FAIL);
    const totalUnits = toNumber(data.testedUnits) || toNumber(data.totalUnits) || toNumber(totalProduction);
    const passCount = Number.isFinite(Number(data.passCount))
        ? Number(data.passCount)
        : Math.round((passPercentage / 100) * totalUnits);
    const failCount = Number.isFinite(Number(data.failCount))
        ? Number(data.failCount)
        : Math.round((failPercentage / 100) * totalUnits);
    return [
        { label: 'Units produced', value: totalProduction || 0, tone: 'neutral' },
        { label: 'Units tested', value: totalUnits, tone: 'neutral' },
        { label: 'First-pass units', value: passCount, tone: 'pass' },
        { label: 'Units requiring retest', value: failCount, tone: 'fail' },
        { label: 'FPY', value: `${passPercentage.toFixed(2)}%`, tone: 'neutral' },
    ];
};

export const getActiveFilters = ({ startDate, endDate, ateSwVersion, selectedSerialNumbers, selectedFamilies = [] }) => {
    const filters = [];

    if (startDate) filters.push(`From ${startDate.toLocaleDateString()}`);
    if (endDate) filters.push(`Until ${endDate.toLocaleDateString()}`);
    if (ateSwVersion) filters.push(`ATE SW ${ateSwVersion}`);
    if (selectedSerialNumbers.length) {
        filters.push(`${selectedSerialNumbers.length} serial number${selectedSerialNumbers.length === 1 ? '' : 's'}`);
    }
    if (selectedFamilies.length) {
        filters.push(`${selectedFamilies.length} source famil${selectedFamilies.length === 1 ? 'y' : 'ies'}`);
    }

    return filters;
};

export const quickDateOptions = [
    { label: 'Today', daysBack: 0 },
    { label: 'Yesterday', daysBack: 1 },
    { label: '7 days ago', daysBack: 7 },
    { label: '30 days ago', daysBack: 30 },
];

export const getDateFromDaysBack = (daysBack) => {
    const date = new Date();
    date.setDate(date.getDate() - daysBack);
    return date;
};
